import React from 'react';
import { useLang } from '../i18n/LangContext';
import Reveal from './Reveal';
import { IMG } from '../data/realImages';

const PROJECT_TILES = [
  { img: IMG.construction[2], cat_index: 8, location: 'México' },                  // Concrete Structures
  { img: IMG.electrical[1],   cat_index: 10, location: 'Bajío, MX' },              // Substations
  { img: IMG.agriculture[0],  cat_index: 5, location: 'Jalisco, MX' },             // Greenhouses
  { img: IMG.industrial[0],   cat_index: 0, location: 'Querétaro, MX' },           // Warehouses
  { img: IMG.industrial[5],   cat_index: 3, location: 'Industrial' },              // Fire Protection
  { img: IMG.construction[3], cat_index: 1, location: 'México' },                  // Infrastructure Works
];

const CLIENTS = ['Driscoll\u2019s', 'Bachoco', 'Haskell', 'IQ Chemicals & Labs', 'Federal Judicial', 'CFE'];

export default function Projects() {
  const { t } = useLang();
  const cats = t('projects.categories');

  return (
    <section id="projects" data-testid="projects-section" className="relative py-24 md:py-40 border-t border-[#27272A]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <Reveal className="section-index">{t('projects.index')}</Reveal>
            <Reveal as="h2" className="h-section text-[#F5F5F2] mt-4 max-w-3xl reveal-delay-1">
              {t('projects.title')}
            </Reveal>
          </div>
          <div className="flex flex-col gap-4 md:items-end">
            <Reveal className="text-[#A1A1AA] max-w-md text-sm md:text-base leading-relaxed reveal-delay-2">
              {t('projects.sub')}
            </Reveal>
            <Reveal className="reveal-delay-3 inline-flex items-center gap-3 border border-[#C8102E]/40 bg-[#C8102E]/5 px-4 py-2">
              <span className="w-1.5 h-1.5 bg-[#C8102E]" />
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F5F5F2]">{t('projects.counter_label')}</span>
            </Reveal>
          </div>
        </div>

        {/* Project tiles */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
          {PROJECT_TILES.map((tile, i) => {
            const span = i === 0 ? 'md:col-span-7' : i === 1 ? 'md:col-span-5' : i === 4 ? 'md:col-span-5' : i === 5 ? 'md:col-span-7' : 'md:col-span-6';
            const aspect = i === 0 || i === 5 ? 'aspect-[16/10]' : 'aspect-[4/3]';
            return (
              <Reveal key={i} className={`${span} reveal-delay-${(i % 4) + 1}`}>
                <div data-testid={`project-tile-${i}`} className={`project-tile w-full ${aspect} bg-[#141416] border border-[#27272A]`}>
                  <img src={tile.img} alt={cats[tile.cat_index]} className="w-full h-full object-cover" loading="lazy" />
                  <div className="absolute inset-0 z-10 p-6 md:p-8 flex flex-col justify-between text-white">
                    <div className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-[#C8102E]" />
                      <span className="font-mono text-[10px] tracking-[0.3em] uppercase">{tile.location}</span>
                    </div>
                    <div>
                      <div className="font-mono text-[10px] tracking-[0.3em] text-[#C8102E] uppercase">Category</div>
                      <div className="mt-1 font-display text-2xl md:text-3xl tracking-tight">{cats[tile.cat_index]}</div>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        {/* All categories */}
        <Reveal className="mt-16 border-t border-[#27272A] pt-12 reveal-delay-2">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#A1A1AA] mb-6">
            Full Project Categories — 11
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-3">
            {cats.map((c, i) => (
              <div key={c} className="flex items-baseline gap-3 text-[#F5F5F2]">
                <span className="font-mono text-[10px] text-[#C8102E]">{String(i + 1).padStart(2, '0')}</span>
                <span className="font-display tracking-tight">{c}</span>
              </div>
            ))}
          </div>
        </Reveal>

        {/* Clients */}
        <Reveal className="mt-20 border-t border-[#27272A] pt-12 reveal-delay-3">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#A1A1AA] mb-8">
            {t('projects.clients_label')}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#27272A] border border-[#27272A]">
            {CLIENTS.map((c) => (
              <div key={c} className="bg-[#0F0F11] p-6 flex items-center justify-center font-display text-base md:text-lg tracking-tight text-[#F5F5F2] hover:text-[#C8102E] transition-colors">
                {c}
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
